import { AfterViewInit, ChangeDetectorRef, Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChange, ViewChild } from '@angular/core';
import dxButton from 'devextreme/ui/button';



class _stati {
  id: number;
  stato: boolean;
}
class _tbOption {
  position?: string;
  width?: string;
  background?: string;
  bootstrapClass?: string
}
class _tasto {
  id: any;
  text?: string;
  icon?: string;
  disabled?: boolean;
  image?: string;
  separator?: boolean;
  visible?: boolean | Function;
  hint?: string;
  name?: string
  location?: 'before' | 'center' | 'after';
  widget: string = 'button'
  width?: number
}


@Component({
  selector: 'app-toolbar',
  templateUrl: './toolbar.component.html',
  styleUrls: ['./toolbar.component.css']
})
export class ToolbarComponent implements OnInit, AfterViewInit {

  @Input() tastiUp: [];
  @Input() tastiBottom: [];
  @Input() buttonsClass: string = '';

  @Input() buttonCustomUp: [] = [];
  @Input() buttonCustomBottom: [] = [];
  @Input() customNewRowBtn: string = 'Nuovo';

  /* Opzioni da passare a app.toolbar
    * position: horizontal|vertical
    * width:%|px
    * background:hex
    * bootstrapClass: col-xxx
  */

  @Input() position: string;
  @Input() disabled: boolean
  @Input() width: string;
  @Input() textColor: string;
  @Input() height: string;
  @Input() background: '';
  @Input() isDx?: boolean = true;
  @Input() bootstrapClass: string;



  /*--TEST---*/

  @Input() bottoniScelti: [];
  @Input() hoverMode: boolean;

  @Output() risposta: EventEmitter<any> = new EventEmitter<any>();
  @Output() valueChangeEvent: EventEmitter<any> = new EventEmitter<any>();
  @Output() onFocus: EventEmitter<any> = new EventEmitter<any>();

  dsTastiUp: _tasto[] = [];

  dsTastiBottom: _tasto[] = [];
  dsButton: dxButton[];
  sidebarOption: _tbOption[];

  orientation: string;
  itemMode: string = '';


  constructor(private cdr:ChangeDetectorRef) {

    //this.selectTab = this.selectTab.bind(this);  

  }
  ngAfterViewInit(): void {
this.cdr.detectChanges()
  }
  disegna() {
    let tastivisibili: boolean[] = [];
    this.orientation = this.position

    const templateButton = [
      { text: 'Chiudi', icon: 'dx-icon dx-icon-close', visible: true, image: '', hint: 'Log OutA', widget: 'button', id: 0 },
      { text: 'Azioni', icon: 'bi bi-bell', visible: true, image: '', hint: 'Azioni', widget: 'button', id: 1 },
      { text: 'Chat', icon: 'bi bi-chat', visible: true, image: '', hint: 'Chat', widget: 'button', id: 2 },
      { text: 'Team', icon: 'bi bi-people', visible: true, image: '', hint: 'Utenti', widget: 'button', id: 3 },
      { text: 'Calendario', icon: 'bi bi-calendar3', visible: true, image: '', hint: 'conferma', widget: 'button', id: 4 },
      { text: 'Chiama', icon: 'bi bi-telephone', visible: true, image: '', hint: 'Annulla', widget: 'button', id: 5 },
      { text: 'File', icon: 'bi bi-file-earmark', visible: false, image: '', hint: 'Attiva Licenza', widget: 'button', id: 6 },
      { text: 'Azioni', icon: 'bi bi-three-dots', visible: true, image: '', hint: 'more', widget: 'button', id: 7 },
      { text: 'Applicazioni', icon: "bi bi-app", visible: true, image: '', hint: 'Applicazioni', widget: 'button', id: 8 },
      { text: 'Guida', icon: "bi bi-question-circle", visible: true, image: '', hint: 'Guida', widget: 'button', id: 9 },
      { text: 'Crea Azienda', icon: "", visible: true, image: 'assets/icons/icons8-database-32.png', hint: 'Crea Azienda', widget: 'button', id: 10 },
      { text: 'Attiva Licenza', icon: "bi bi-activity", visible: true, image: '', hint: 'Attiva Licenza', widget: 'button', id: 11 },
      { text: 'Modifica PDF', icon: 'icon-pencil', visible: true, image: '', hint: 'Modifica PDF', widget: 'button', id: 12 },
      { text: 'Invia Email', icon: 'icon-mail', visible: true, image: '', hint: 'Invia Email', widget: 'button', id: 13 },
      { text: 'Elenco Soggetti', icon: 'bi bi-reply-fill', visible: true, image: '', hint: 'Torna alla lista soggetti', widget: 'button', id: 14 },
      { text: 'Salva', icon: 'icon-salva-form', visible: true, image: '', hint: 'Salva', widget: 'button', id: 15, },
      { text: 'Ritorna', icon: 'icon-annulla-form', visible: true, image: '', hint: 'Torna indietro', widget: 'button', id: 16 },
      { text: 'Utility', icon: 'mdi mdi-settings-outline', visible: true, image: '', hint: 'Utility', widget: 'button', id: 17 },
      { text: 'Esporta in Docx', icon: 'icon-file-word', visible: true, image: '', hint: 'Esporta in Docx', widget: 'button', id: 18 },
      { text: 'Esporta in Pdf', icon: 'icon-file-pdf', visible: true, image: '', hint: 'Esporta in Pdf', widget: 'button', id: 19 },
      { text: 'Esporta in Xlsx', icon: 'icon-file-excel', visible: true, image: '', hint: 'Esporta in Xlsx', widget: 'button', id: 20 },
      { text: this.customNewRowBtn, icon: 'icon-plus-circled', visible: true, image: '', hint: this.customNewRowBtn, widget: 'button', id: 21 },
      { text: 'Conferma', icon: 'icon-salva-form', visible: true, image: '', hint: 'Conferma', widget: 'button', id: 22 },
      { text: 'Annulla', icon: 'icon-annulla-form', visible: true, image: '', hint: 'Annulla', widget: 'button', id: 23 },
      { text: 'Crea Registro R.e.n.Tri.', icon: 'mdi mdi-settings-outline', visible: true, image: '', hint: 'Crea Registro R.e.n.Tri.', widget: 'button', id: 24 },
      { text: this.customNewRowBtn, icon: 'icon-plus-circled', visible: true, image: '', hint: this.customNewRowBtn, widget: 'button', id: 25, },
      { text: 'Elabora', icon: 'bi bi-activity', visible: true, image: '', hint: 'Elabora', widget: 'button', id: 26 },
      { text: 'Aggiorna Coordinate', icon: 'dx-icon dx-icon-map', visible: true, image: '', hint: 'Coordinate', widget: 'button', id: 27 },
      { text: 'Aggiungi Diario', icon: 'dx-icon-plus', visible: true, image: '', hint: 'Aggiungi Diario', widget: 'button', id: 28 },
      { text: 'Invia Contratto', icon: 'dx-icon-greater', visible: true, image: '', hint: 'Invia Contratto', widget: 'button', id: 29 },
      { text: 'Prosegui con l`invio del Censimento', icon: 'dx-icon-greater', visible: true, image: '', hint: 'Prosegui con l`invio del Censimento', widget: 'button', id: 30 },
    ];

    if (this.tastiUp && this.tastiUp.length > 0) {
      this.dsTastiUp = this.tastiUp.map((res, c) => {
        if (typeof templateButton[res] != 'undefined')
          return templateButton[res];
      })
    }


    if (this.buttonCustomUp && this.buttonCustomUp.length > 0) {
      this.buttonCustomUp.forEach(button => {
        this.dsTastiUp.push(button)
      })

    }



    if (typeof this.tastiBottom != 'undefined' && this.tastiBottom.length > 0)
      if (this.tastiBottom && this.tastiBottom.length > 0)
        this.dsTastiBottom = this.tastiBottom.map((res, c) => {
          if (typeof templateButton[res] != 'undefined')
            return templateButton[res];

        })

    if (this.buttonCustomBottom && this.buttonCustomBottom.length > 0) {

      this.buttonCustomBottom.forEach(button => {

        this.dsTastiBottom.push(button)
      })
    }

    //console.log('dsTastiBottom--->',this.dsTastiBottom)

  }

  ngOnInit(): void {

    //console.warn(this.buttonCustomBottom,this.buttonCustomUp,this.tastiUp);

    this.disegna();


    if (this.hoverMode) {
      this.itemMode = 'in-line'
    }

  }

  selectTab(e: any) {
     console.log(e)
    if (typeof e.itemData == 'undefined') {
      e.itemData = JSON.parse(JSON.stringify(e)) ///!! se non funziona toolbar rimuovere JSON.parse 
    }
    let risposta = '';
    let index = e.itemData.id;

    if (e.itemData.event) {
      risposta = e.itemData
    } else {
      risposta = index
    }

    this.risposta.emit(risposta);
  }

  setStateActive(ev) {

    this.removeStateActive(ev)
    this.buttonsClass = this.buttonsClass.concat('input-active')
    //this.onFocus.emit(ev)
  }
  removeStateActive(ev) {

    if (this.buttonsClass.includes('input-active')) {
      this.buttonsClass = this.buttonsClass.replace('input-active', '');
      return
    }


    //this.onFocus.emit(ev)
  }

  onInput(event, input) {

    let dataToSendEmit = {
      value: input.value,
      event: event,
      textBox: event.target
    }

    this.valueChangeEvent.emit(dataToSendEmit)
  }

  initialized(event, menuName) {
    event.name = 'initialized',
      event.menuName = menuName,
      this.risposta.emit(event)
  }
  changeStatusBtnBottom(id:number,attivo:boolean) {
    this.dsTastiBottom.find((btn) => btn.id === id).disabled = !attivo
    this.cdr.detectChanges()
  }
}
